import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from '../../base.service';

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseService{


  getDetail(id?: any): Observable<any> {
    return this.get<any>(`/customer/${id}`);
  }

  getFieldsExport(): Observable<any> {
    return this.get<any>(`/customer/fields`);
  }

  exportExport(params): Observable<any> {
    return this.post<any>(`/customer/export`, {},{ params: params, responseType: 'blob'});
  }
  
}
